import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  private storagePrefix = 'roarchat_token_';
  
  constructor() {}

  private getStorageKey(conversationId: string): string {
    return `${this.storagePrefix}${conversationId}`;
  }

  store(conversationId: string, accessToken: string, refreshToken: string): void {
    if(!accessToken) return;

    const detail: storageTokenModel = {
      accessToken: accessToken,
      refreshToken: refreshToken,
      advisorName: '',
      lastChatMessage: '',
      lastUpdate: new Date().toISOString()
    }

    localStorage.setItem(this.getStorageKey(conversationId), JSON.stringify(detail));
  }

  get(conversationId: string): storageTokenModel | null {
    const data =  localStorage.getItem(this.getStorageKey(conversationId));
    if(!data) return null;
    
    try {
        return JSON.parse(data) as storageTokenModel;
    } catch (error) {
        return null
    }
  }

  delete(conversationId: string): void {
    localStorage.removeItem(this.getStorageKey(conversationId));
  }

  update(conversationId: string, advisorName: string, lastMessageDate: string ): void {
    const existing = this.get(conversationId);
    if(existing == null) return;

    const merged: storageTokenModel = {
      accessToken: existing.accessToken,
      refreshToken: existing.refreshToken,
      advisorName: advisorName,
      lastChatMessage: lastMessageDate,
      lastUpdate: new Date().toISOString()
    };

    localStorage.setItem(this.getStorageKey(conversationId), JSON.stringify(merged));
  }

  getAllStorageConversations(): Array<{conversationId: string, details: storageTokenModel | null}> {
    const conversationDetails = Object.keys(localStorage)
      .filter(key => key.startsWith(this.storagePrefix))
      .map(key => {
        const conversationId = key.slice(
          this.storagePrefix.length, 
          key.length
        );
        return {
          conversationId,
          details: this.get(conversationId)
        };
      })
      .filter(key => key.details && key.details.accessToken);

    return conversationDetails;
  }
}